<template>
	<div class="reply" >
    <div class="header">
      <div class="left">
        <div v-if="reply.operator">
          <img :src='currentConsultImgSrc' >
          <span class="subject">{{reply.operator.userName}}</span>
          <span class="action">回答</span>
        </div>
        <div v-else>
          <span class="subject">我</span>
          <span class="action">补充</span>
        </div>
      </div>
      <div class="right">
        {{ date }}
      </div>
    </div>
    <div class="content ">
      <p>{{ reply.reply }}</p>
    </div>
	</div>
</template>

<script>
import { getChatTime } from '@/utils/date'
export default {
  name: 'ReplyDetailBox',
  props: {
    reply: {},
    title: String,
  },

  computed: {
    date() {
      return getChatTime(new Date(this.reply.createTime))
    },
		currentConsultImgSrc() {
			return 'http://sys.rennengda.com/public/images/consult/consult-1.jpg'
		},    
  },

  methods: {
    handleClick() {
        this.$emit('playMission',this.missionId)
    },
  }
}
</script>

<style lang="stylus" scoped>
.reply
  margin: 0.16rem 0
  .header
    display: flex
    overflow: hidden
    .left
      float:left
      img
        width:0.5rem
        height:0.5rem
      .subject
        color:#008DCF
        padding-left:0.12rem        
        padding-right:0.12rem
      .action
        color:#999
        padding-right:0.12rem
    .right
      margin-left:0.12rem
      float:right
      font-size :0.24rem
      color:#999
  .content
    font-size:0.24rem
    color:#777
    margin-top:0.1rem
    line-height:0.3rem
</style>
